export function trackHistory() {
  const currentPath = window.location.href;

  // Get existing data
  let historyStack = JSON.parse(sessionStorage.getItem('routeHistoric')) || [];
  const storedIndex = sessionStorage.getItem('routeHistoryIndex');

  // Check if null strictly. 0 is a valid index
  let currentIndex = storedIndex !== null ? parseInt(storedIndex) : -1;

  // Prevent duplicate entries if reloading the exact same page
  if (historyStack[currentIndex] === currentPath) {
    return;
  }

  // Handle Branching
  // If went back and then navigated somewhere new, cut off the old "forward" history
  // If currentIndex is -1, slice(0, 0) gives an empty array to start fresh
  historyStack = historyStack.slice(0, currentIndex + 1);

  // Push new page and update index
  historyStack.push(currentPath);
  currentIndex++;

  // 5. Save
  sessionStorage.setItem('routeHistoric', JSON.stringify(historyStack));
  sessionStorage.setItem('routeHistoryIndex', currentIndex.toString());
}
